import React, { useState } from 'react';
//import s from './Home.module.scss';

//Componente
import Navbar from '../Navbar';
import ProductGrid from '../ProductGrid';
import Carousel from '../Carousel';
import Contact from '../Contact';
import MobileMenu from '../Navbar/MobileMenu';
import About from '../About';
import Footer from '../Footer';
import CustomerCarousel from "../CustomerCarousel";
import WspButton from "../WspButton";


//Material UI
import {
	Grid,
} from '@mui/material';



const Home = () => {

	const [open, setOpen] = useState(false);

	return(
		<Grid container >
                  <WspButton/> 
                  <MobileMenu open={open} setOpen={setOpen}/>
                  <Navbar setOpen={setOpen}/>
                  <Carousel/>
                  <ProductGrid/>
                  <About/>
                  <CustomerCarousel/>
                  <Contact/>
                  <Footer/> 
		</Grid>
	)
}

export default Home;